// 用户模块上下文

import { createContext, useContext, ReactNode } from "react";
import { useUserData, useUserAuth } from "../stores";
import { userService } from "../services";
import { useBaseCache } from "../../base/contexts";
import { useUserEvents } from "../hooks/useUserEvents";

// Context类型定义
interface UserContextType {
  // 用户数据
  userData: ReturnType<typeof useUserData>;
  // 用户认证
  userAuth: ReturnType<typeof useUserAuth>;
  // 用户服务
  userService: typeof userService;
  // 基础缓存
  cache: ReturnType<typeof useBaseCache>;
}

// 创建Context
const UserContext = createContext<UserContextType | null>(null);

// Provider Props
interface UserContextProviderProps {
  children: ReactNode;
}

// Provider组件
export function UserContextProvider({ children }: UserContextProviderProps) {
  const userData = useUserData();
  const userAuth = useUserAuth();
  const cache = useBaseCache();

  useUserEvents();

  const value: UserContextType = {
    userData,
    userAuth,
    userService,
    cache,
  };

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
}

// Hook
export function useUserContext(): UserContextType {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error("useUserContext must be used within UserContextProvider");
  }
  return context;
}
